import { Typography } from "@mui/material";
import { Controller, FieldValues, Path, Control } from "react-hook-form";
import { DatePicker, DatePickerProps } from "@mui/x-date-pickers/DatePicker";
import React, { ReactNode } from "react";
import Calendar from "@icons/myicons/calendar.svg?react";

interface Props<T extends FieldValues>
  extends Omit<
    DatePickerProps<any, any>,
    "renderInput" | "onChange" | "value" | "name"
  > {
  label?: ReactNode;
  placeholder?: string;
  optional?: boolean;
  testId?: string;
  name: Path<T>;
  control: Control<T>;
}

export const RHFDatePicker = <T extends FieldValues>({
  name,
  label,
  placeholder,
  optional = false,
  testId,
  control,
  ...props
}: Props<T>) => {
  const Label = (
    <>
      {label}
      {optional ? (
        <Typography color="textSecondary" component="span" variant="body3">
          {" "}
          (optional)
        </Typography>
      ) : (
        ""
      )}
    </>
  );

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <DatePicker
            onChange={field.onChange}
            value={
              typeof field.value === "string"
                ? new Date(field.value)
                : field.value
            }
            format="dd.MM.yyyy"
            slots={{
              openPickerIcon: () => <Calendar width="20px" height="20px" />,
            }}
            slotProps={{
              popper: {
                sx: {
                  marginLeft: "23px !important",
                },
                disablePortal: true,
              },
              textField: {
                fullWidth: true,
                inputProps: {
                  "data-testid": testId || "calendar-input",
                  sx: {
                    "&::placeholder": {
                      color: "text.secondary",
                      opacity: 1,
                    },
                  },
                },
                label: Label,
                placeholder: placeholder,
                error: !!error,
                helperText: error?.message,
              },
            }}
            {...props}
          />
        );
      }}
    />
  );
};
